var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c((_vm.$store.state.auth.user.settings.dashboard || 'default'),{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }